<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li [routerLink]='["../../list"]'>My Pre owned Supply </li>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>View</li>
    </ul>
  </div>
  <section class="master_view_sec">
    <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
      fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
      <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100" fxFlexFill>
        <div class="custom-tabs supplies_custom_tabs">
          <!-- mat-tab-group -->
          <mat-tab-group [@.disabled]="true">
            <!-- Product Details-TAB -->
            <mat-tab class="gallery-tab">
              <ng-template mat-tab-label>
                Product Details
              </ng-template>
              <!-- TABS-BODY -->
              <section class="tabs-body">
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                  fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                  <div fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                    fxFlexFill>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Product title
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSecondHandSupply.title}}</p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Brand Name
                        <span class="dots">:</span>
                      </label>
                      <p class="value"> {{oldSecondHandSupply?.supply_brand?.name}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Category
                        <span class="dots">:</span>
                      </label>
                      <p class="value"> {{oldSecondHandSupply?.supply_category?.name}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Sub category
                        <span class="dots">:</span>
                      </label>
                      <p class="value"> {{oldSecondHandSupply?.supply_sub_category?.name}} </p>
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Color
                        <span class="dots">:</span>
                      </label>
                      <p class="value">
                        <span class="colorBox"
                        [ngStyle]="{'background-color': oldSecondHandSupply.color, 'border-color': oldSecondHandSupply.color  }">
                      </span>
                      </p>
                      <!-- <div class="value colorBox" [ngStyle]="{'background-color': oldSecondHandSupply.color }"></div> -->
                    </div>
                    <div class="custom_form_group">
                      <label for="" class="custom_label">Product Type
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSecondHandSupply.product_type | titlecase }}</p>
                    </div>
                    <ng-container *ngIf="['BOTH', 'ONLY_BUY_NOW'].includes(oldSecondHandSupply.product_type)">
                      <div class="custom_form_group">
                        <label for="" class="custom_label">Buy Now Price
                          <span class="dots">:</span>
                        </label>
                        <p class="value">AUD {{oldSecondHandSupply.buy_now_price.toFixed(2)}}</p>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="['BOTH', 'ONLY_BIDING'].includes(oldSecondHandSupply.product_type)">
                      <div class="custom_form_group">
                        <label for="" class="custom_label">Minimum Bid Value
                          <span class="dots">:</span>
                        </label>
                        <p class="value">AUD {{oldSecondHandSupply.starting_price.toFixed(2)}}</p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label">Bid Starts At
                          <span class="dots">:</span>
                        </label>
                        <p class="value"> {{oldSecondHandSupply.bid_starts_at| date: 'dd-MM-yyyy hh:mm a'}} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label">Bid Ends At
                          <span class="dots">:</span>
                        </label>
                        <p class="value"> {{oldSecondHandSupply?.bid_ends_at|date: 'dd-MM-yyyy hh:mm a'}} </p>
                      </div>
                    </ng-container>
                    <div class="custom_form_group">
                      <label for="" class="custom_label"> Featured Image
                        <span class="dots">:</span>
                      </label>
                      <ul class="imgs_listing">
                        <li>
                          <img [src]="oldSecondHandSupply?.image?.url" class="preview_img" />
                        </li>
                      </ul>
                    </div>
                    <div class="custom_form_group custom_form_group_mobile" *ngIf="oldSecondHandSupply?.more_images">
                      <label for="" class="custom_label"> Images
                        <span class="dots">:</span>
                      </label>
                      <ul class="imgs_listing">
                        <li *ngFor="let single of oldSecondHandSupply?.more_images">
                          <img [src]="single.url" class="preview_img" />
                        </li>
                      </ul>
                    </div>
                    <div class="custom_form_group custom_form_group_mobile" *ngIf="oldSecondHandSupply?.video?.url">
                      <label for="" class="custom_label"> Featured Video
                        <span class="dots">:</span>
                      </label>
                      <ul class="video-list">
                        <li class="">
                          <video [src]="oldSecondHandSupply?.video?.url" class="preview_video" controls></video>
                        </li>
                      </ul>
                    </div>
                    <h4 class="custom_sub_heading mb-20 mt-20"> Freight Charge </h4>
                    <div class="custom_form_group">
                      <label for="" class="custom_label"> Type
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSecondHandSupply?.freight_charge?.type }} </p>
                    </div>
                    <div class="custom_form_group"
                      *ngIf="oldSecondHandSupply?.freight_charge?.type === 'FLAT'">
                      <label for="" class="custom_label"> Amount
                        <span class="dots">:</span>
                      </label>
                      <p class="value">{{oldSecondHandSupply?.freight_charge?.amount }} </p>
                    </div>
                    <ng-container *ngFor="let singleRegion of oldSecondHandSupply.freight_charge.metro_regions">
                      <div class="freight_box_view">
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Name
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{ singleRegion?.name }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Pin codes
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{singleRegion?.pincodes }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Amount
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{singleRegion?.amount }} </p>
                      </div>
                    </div>
                    </ng-container>
                    <ng-container *ngIf="oldSecondHandSupply?.freight_charge?.type === 'PICKUP'">
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Namesss
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.short_name }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Address line 1
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.line_1 }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Address line 2
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.line_2 }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Landmark
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.landmark }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> City
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.city }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> State
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.state }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Country
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.country }} </p>
                      </div>
                      <div class="custom_form_group">
                        <label for="" class="custom_label"> Postal Code
                          <span class="dots">:</span>
                        </label>
                        <p class="value">{{oldSecondHandSupply?.freight_charge?.address.postal_code }} </p>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </section>
            </mat-tab>
            <!-- Descrition Details-TAB -->
            <mat-tab class="gallery-tab">
              <ng-template mat-tab-label>
                Product description
              </ng-template>
              <!-- TABS-BODY -->
              <section class="tabs-body">
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                  fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                  <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                    fxFlexFill>
                    <div class="custom_form_group custom_form_group_mobile">
                      <label for="" class="custom_label">Specifications
                        <span class="dots">:</span>
                      </label>
                      <div class="value" [innerHTML]="oldSecondHandSupply.specifications"> </div>
                    </div>
                    <div class="custom_form_group custom_form_group_mobile">
                      <label for="" class="custom_label">Short Description
                        <span class="dots">:</span>
                      </label>
                      <div class="value" [innerHTML]="oldSecondHandSupply?.description"> </div>
                    </div>
                  </div>
                </div>
              </section>
            </mat-tab>
            <!-- SEO-TAB -->
            <mat-tab class="gallery-tab">
              <ng-template mat-tab-label>
                SEO
              </ng-template>
              <!-- TABS-BODY -->
              <section class="tabs-body">
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                  fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                  <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                    fxFlexFill>
                    <!-- <h4 class="custom_sub_heading mt-20 mb-10"> Seo </h4> -->
                    <div class="custom_form_group">
                      <label for="" class="custom_label"> Pager Title
                        <span class="dots">:</span>
                      </label>
                      <p class="value">
                        {{oldSecondHandSupply?.seo_metadata?.title ? oldSecondHandSupply?.seo_metadata?.title  : 'NA' }}
                      </p>
                    </div>
                    <div class="custom_form_group ">
                      <label for="" class="custom_label"> Keywords
                        <span class="dots">:</span>
                      </label>
                      <p class="value">
                        <ng-container
                          *ngIf="oldSecondHandSupply?.seo_metadata?.keywords && oldSecondHandSupply?.seo_metadata?.keywords.length">
                          <span *ngFor="let single of oldSecondHandSupply?.seo_metadata?.keywords">{{single}}</span>
                        </ng-container>
                        <ng-container *ngIf="!oldSecondHandSupply?.seo_metadata?.keywords">
                          <span>NA</span>
                        </ng-container>
                      </p>
                    </div>
                    <div class="custom_form_group ">
                      <label for="" class="custom_label"> Image
                        <span class="dots">:</span>
                      </label>
                      <ul class="imgs_listing" *ngIf="oldSecondHandSupply?.seo_metadata?.image">
                        <li>
                          <img [src]="oldSecondHandSupply?.seo_metadata?.image?.url" class="preview_img" />
                        </li>
                      </ul>
                      <p class="value" *ngIf="!oldSecondHandSupply?.seo_metadata?.image"> NA </p>
                    </div>

                    <div class="custom_form_group ">
                      <label for="" class="custom_label"> Alt Text
                        <span class="dots">:</span>
                      </label>
                      <p class="value">
                        {{oldSecondHandSupply?.seo_metadata?.alt_text ? oldSecondHandSupply?.seo_metadata?.alt_text : 'NA' }}
                      </p>
                    </div>
                    <div class="custom_form_group custom_form_group_mobile">
                      <label for="" class="custom_label"> Meta Description
                        <span class="dots">:</span>
                      </label>
                      <p class="value">
                        {{oldSecondHandSupply?.seo_metadata?.description ? oldSecondHandSupply?.seo_metadata?.description: 'NA'}}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </section>
</section>
